import { IconFont } from '@lighthouse/bui'
import styled from 'styled-components'

export const Container = styled.div`
    padding-top: 6px;
`

export const TypeName = styled.div`
    color: var(--color-gray-500);
    font-size: 10px;
    font-weight: var(--font-weight-normal);
    line-height: 20px;
`

export const FieldMoreLineItem = styled.div`
    padding: 4px 8px;
    background: #eceff4;
    border-radius: 4px;
    margin-bottom: 4px;
`

export const FieldMoreLineHeader = styled.div`
    color: var(--color-gray-600);
    font-size: 12px;
    line-height: 20px;
`

export const FieldMoreLineContent = styled.div`
    font-size: 12px;
    line-height: 20px;
    overflow: hidden;
`
